import instance from '../_http';

export default {
    /**
     * 添加
     * @param {*} website
     * @returns
     */
    add: (website) => {
        return instance.post('/api/property/employees',website);
    },
    /**
     *  删除
     */
    remove: (id) => {
        return instance.delete(`/api/property/employees/${id}`);
    },
    /**
     * 更新
     * @param {*} website
     * @returns
     */
    update: (website) => {
        return instance.put('/api/property/employees',website);
    },
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/property/employees',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    },
    /**
     * 详情
     * @param {*} id
     * @returns
     */
    detail: (id) => {
        return instance.get(`/api/property/employees/${id}`);
    },

  /**
   * 查询
   * @param {*} query
   * @returns
   */
   listJobInfo: () => {
    return instance.get('/api/property/jobs-info/list');
  },
  /**
   * 查询
   * @param {*} query
   * @returns
   */
  listEmployeesInfo: () => {
    return instance.get('/api/property/employees/list');
  },

  uploadFile: (data) => {
    return instance.post('/api/property/employees/upload',data);
  },
}
